export const mapBooleanArraysWithOr = (arr1: boolean[], arr2: boolean[]) => {
  if (arr1.length !== arr2.length) {
    throw new Error("Arrays must have the same length");
  }

  const result: boolean[] = arr1.map((value, index) => value || arr2[index]);
  return result;
};
